module.exports = __webpack_public_path__ + "assets/fonts/Gordita-Bold.fd1f233dbe075698d5ab1cd08264b4c8.woff";